import { PharmacistOrderTableView } from '@/context/orders/PharmacistOrders';
import { Alert, AlertTitle, Button, Stack, Typography } from '@montugroup/design-system';

export const OrdersPendingCollectionAlert = ({
  ordersPendingCollection,
  goToPendingCollectionTab,
  activeView,
}: {
  ordersPendingCollection?: number;
  goToPendingCollectionTab: () => void;
  activeView: PharmacistOrderTableView;
}) => {
  if (!ordersPendingCollection || activeView === PharmacistOrderTableView.PENDING_COLLECTION) {
    return null;
  }

  return (
    <Alert
      severity="warning"
      sx={{
        width: '100%',
        '& .MuiAlert-message': {
          flex: 1,
        },
      }}
    >
      <Stack direction={{ md: 'row' }} gap={3} justifyContent={'space-between'} alignItems={'flex-start'}>
        <Stack>
          <AlertTitle>You have {ordersPendingCollection} orders waiting for customer collection</AlertTitle>
          <Typography variant="body2">
            <Typography variant="body2" display={'inline'}>
              Please go to <strong>Pending collection</strong> tab to mark orders as collected as customer picks the
              orders up.
            </Typography>{' '}
            <Typography variant="body2" display={'inline'} noWrap>
              This helps keep your queue clear and up to date.
            </Typography>
          </Typography>
        </Stack>
        <Button
          variant="contained"
          color="secondary"
          onClick={goToPendingCollectionTab}
          sx={{
            whiteSpace: 'nowrap',
            flexShrink: 0,
          }}
        >
          <Typography variant="body2">
            Go to <strong>Pending collection</strong> tab
          </Typography>
        </Button>
      </Stack>
    </Alert>
  );
};
